import React from 'react'
import { Badge } from 'reactstrap'

// The API is the source of truth; missing status is never assumed available.
export const AvailabilityBadge = ({ product }) => {
  const available = product?.availability === 'available'
  return <Badge color={available ? 'success' : 'danger'}>{available ? 'AVAILABLE' : 'NOT AVAILABLE'}</Badge>
}
